module.exports = __webpack_public_path__ + "static/media/ubuntu1804.cc54965e.jpg";